module.exports = __webpack_public_path__ + "img/logo.04e3ad11.png";